import { FactoryProvider } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { CurrentUserAndPermissions } from './current-user-and-permissions';
import { CURRENT_USER } from './current-user.constant';

export function getCurrentUserFromRoute(
  route: ActivatedRoute,
): CurrentUserAndPermissions {
  return route.snapshot.data.currentUser;
}

export const CurrentUserFactoryProvider: FactoryProvider = {
  provide: CURRENT_USER,
  useFactory: getCurrentUserFromRoute,
  deps: [ActivatedRoute],
};
